import { RoundIntegrityWatcher, RoundIntegrityWatcherPhases } from '../../../logger/RoundIntegrityWatcher';
import { ChipSelectionOrigin, type ChipValueType } from '../../../store';
import { fetchUserInfoAction } from '../../../store/apiActions/fetchUserInfoAction';
import type { CoreStoreType } from '../../../store/CoreStore';
import { chipActions } from '../../../store/slices/chips/slice';
import type { GameCommunicationMessageType, IGameCommunicationProcessor } from '../types';

export class GameCommunicationStartDealingProcessor implements IGameCommunicationProcessor {
  messageName = 'startDealing';

  private lastDispatchedChip: ChipValueType | null = null;

  process(message: GameCommunicationMessageType, store: CoreStoreType): void {
    RoundIntegrityWatcher.setPhase(RoundIntegrityWatcherPhases.StartDealing);

    const { chips, config } = store.getState();
    const selectedChip = chips.selectedChip;
    const session = config?.session;
    const JSESSIONID = session?.JSESSIONID;
    const baseUrl = session?.metaServer;

    if (JSESSIONID && baseUrl) {
      store.dispatch(fetchUserInfoAction({ JSESSIONID, baseUrl, force: true, essential: true }));
    }

    // Save initially selected chip on server after betting phase is over.
    if (!this.lastDispatchedChip && selectedChip && selectedChip.selectedBy === ChipSelectionOrigin.System) {
      store.dispatch(chipActions.setAndSyncSelectedChip(selectedChip));
      this.lastDispatchedChip = selectedChip;
    }

    // Save system selected chip on server after betting phase is over.
    if (
      this.lastDispatchedChip &&
      selectedChip &&
      selectedChip.selectedBy === ChipSelectionOrigin.System &&
      selectedChip.weight !== this.lastDispatchedChip?.weight
    ) {
      store.dispatch(chipActions.setAndSyncSelectedChip(selectedChip));
      this.lastDispatchedChip = selectedChip;
    }
  }
}
